import { render } from "./schedule.vue?vue&type=template&id=b24f3a10&scoped=true&ts=true"
import script from "./schedule.vue?vue&type=script&lang=ts"
export * from "./schedule.vue?vue&type=script&lang=ts"

import "./schedule.vue?vue&type=style&index=0&id=b24f3a10&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b24f3a10"]])

export default __exports__